export default __webpack_public_path__ + "static/media/EITHealth-logo.72ce85d5.png";